import type { FieldId, WellBrief, WellsByField } from '@core/core/types'
import type { PayloadAction } from '@reduxjs/toolkit'
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'

import {
  loadHotStorageFieldsHavingWellsData,
  loadHotStorageWellsHavingDataForField,
} from './wellsByFieldsActions'

export const wellsByFieldAdapter = createEntityAdapter<WellsByField>({
  selectId: field => field.id,
  sortComparer: (e1, e2) => e1.name.localeCompare(e2.name),
})

const slice = createSlice({
  name: 'wellsByField',
  initialState: wellsByFieldAdapter.getInitialState(),
  reducers: {
    setFields(state, action: PayloadAction<WellsByField[]>) {
      wellsByFieldAdapter.setMany(state, action.payload)
    },
    setWells(state, action: PayloadAction<{ id: FieldId; wells?: WellBrief[] }>) {
      const { id, wells } = action.payload
      wellsByFieldAdapter.updateOne(state, { id, changes: { wells } })
    },
    removeAllFields(state) {
      wellsByFieldAdapter.removeAll(state)
    },
  },
  extraReducers: builder => {
    builder
      .addCase(loadHotStorageFieldsHavingWellsData.fulfilled, (state, action) => {
        wellsByFieldAdapter.setMany(state, action.payload)
      })
      .addCase(loadHotStorageWellsHavingDataForField.fulfilled, (state, action) => {
        const { fieldId, wells } = action.payload
        wellsByFieldAdapter.updateOne(state, { id: fieldId, changes: { wells } })
      })
  },
})

export const wellsByFieldReducer = slice.reducer
export const wellsByFieldActions = slice.actions
